import React, { FC } from 'react';

import router, { RouteItemType } from '~/core/router';
import projectConfig from '~/projects/config';
import LegalPage from '~/projects/polyllm-chat/components/LegalPage';
import {
  privacyPolicyMarkdown,
  subscriptionTermsMarkdown,
  termsOfUseMarkdown,
} from '~/projects/polyllm-chat/components/LegalPage/content';

const PrivacyPolicyPath = '/legal/privacy-policy';
const SubscriptionTermsPath = '/legal/subscription-terms';
const TermsOfUsePath = '/legal/terms-of-use';

const LEGAL_LAST_UPDATED = 'April 1, 2026';

const legalMarkdownVariables = {
  COMPANY_LEGAL_NAME: 'AV Wellbeing',
  EFFECTIVE_DATE: LEGAL_LAST_UPDATED,
  LAST_UPDATED: LEGAL_LAST_UPDATED,
  SITE_NAME: projectConfig.getProjectName(),
  SUPPORT_EMAIL: projectConfig.getSupportEmail(),
  WEBSITE_URL: process.env.SITE_BASE_URL || '',
};

const PrivacyPolicyPage: FC = () => (
  <LegalPage
    markdown={privacyPolicyMarkdown}
    variables={legalMarkdownVariables}
  />
);

const SubscriptionTermsPage: FC = () => (
  <LegalPage
    markdown={subscriptionTermsMarkdown}
    variables={legalMarkdownVariables}
  />
);

const TermsOfUsePage: FC = () => (
  <LegalPage markdown={termsOfUseMarkdown} variables={legalMarkdownVariables} />
);

const getPrivacyTitle = (): string => 'Privacy Policy';
const getSubscriptionTermsTitle = (): string => 'Subscription Terms';
const getTermsTitle = (): string => 'Terms of Use';

const LegalRoutes: RouteItemType[] = [
  {
    Component: PrivacyPolicyPage,
    path: PrivacyPolicyPath,
    getTitle: getPrivacyTitle,
  },
  {
    Component: SubscriptionTermsPage,
    path: SubscriptionTermsPath,
    getTitle: getSubscriptionTermsTitle,
  },
  {
    Component: TermsOfUsePage,
    path: TermsOfUsePath,
    getTitle: getTermsTitle,
  },
];

router.addUnAuthorizedRoutes(LegalRoutes);
